import React from "react";
import azureRank from "./assets/azureRank.svg";
import crystalRank from "./assets/crystalRank.svg";
import eclipseRank from "./assets/eclipseRank.svg";
import sapphireRank from "./assets/sapphireRank.svg";
import rightArrow from "./assets/rightArrow.svg";
import leaderboardIcon from "./assets/leaderboardIcon.png";
import airdropIcon from "./assets/airdropIcon.png";
import progressIcon from "./assets/progressIcon.png";
import diamond from "./assets/diamond.svg";
import "./newleaderboard.css";
import { NavLink } from "react-router-dom";
import getFormattedNumber from "../../hooks/getFormattedNumber";

const MainView = ({ rank, nextThreshold, currentXp, percentage }) => {
 

  return (
    <div className="container-fluid leaderboard-wrapper pb-3 px-0">
      <div className="d-flex flex-column gap-4">
        <div className="main-view-rank-wrapper p-3 d-flex flex-column gap-2">
          <div className="d-flex align-items-center gap-3">
            <img
              src={
                rank === 1
                  ? sapphireRank
                  : rank === 2
                  ? azureRank
                  : rank === 3
                  ? crystalRank
                  : eclipseRank
              }
              className="main-view-rank-image"
              alt=""
            />
            <div className="d-flex flex-column gap-3">
              <h6 className="mb-0 main-view-rank-comment">
                {rank === 1
                  ? "You're off to a great start!"
                  : rank === 2
                  ? "You're almost there!"
                  : rank === 3
                  ? "Just a little more to go!"
                  : "You did it!"}
              </h6>
              <div className="d-flex flex-column gap-2">
                <span className="xp-left">
                  {rank !== 4
                    ? "xp left to collect"
                    : "Top-tier badge unlocked"}
                </span>
                {rank !== 4 && (
                  <span className="xp-left-value">
                    {getFormattedNumber(
                      nextThreshold - currentXp <= 0
                        ? 0
                        : nextThreshold - currentXp,
                      0
                    )}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="pe-3">
            <div className="leaderboard-progress-bar w-100">
              <div
                className="leaderboard-progress-bar-value"
                style={{ width: `${percentage}%` }}
              ></div>
              <div
                className="next-rank-wrapper d-flex align-items-center justify-content-center"
                style={{ background: rank === 4 ? "#5690ff" : "#e5e8f0" }}
              >
                <img
                  src={
                    rank === 1
                      ? azureRank
                      : rank === 2
                      ? crystalRank
                      : rank === 3
                      ? eclipseRank
                      : diamond
                  }
                  className="main-view-next-rank"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="d-flex w-100 align-items-start justify-content-between mt-2">
            <span className="current-lb-score">
              {getFormattedNumber(currentXp, 0)}
            </span>
            <div className="d-flex flex-column align-items-end">
              <span className="current-lb-score">
                Goal{" "}
                {getFormattedNumber(
                  nextThreshold === 0 || nextThreshold === null
                    ? 100100
                    : nextThreshold,
                  0
                )}
              </span>
              <span className="next-lb-rewards">$5 rewards</span>
            </div>
          </div>
        </div>
        <div className="d-flex flex-column gap-3 px-3">
          <NavLink
            to={"/leaderboard/progress"}
            state={{rank: rank}}  
            className="progress-tab-wrapper d-flex align-items-center justify-content-between"
          >
            <div className="d-flex flex-column gap-3 p-3">
              <h6 className="mb-0 progress-tab-title">Progress</h6>
              <span className="progress-tab-desc">
                Earn badges by completing multiple tasks
              </span>
              <div className="progress-tab-arrow-wrapper d-flex align-items-center justify-content-center">
                <img src={rightArrow} width={12} height={12} alt="" />
              </div>
            </div>
            <div className="progress-tab-image-wrapper">
              <img src={progressIcon} className="progress-icon" alt="" />
            </div>
          </NavLink>
          <NavLink
            to={"/leaderboard/ranks"}
            className="leaderboard-tab-wrapper d-flex align-items-center justify-content-between"
          >
            <div className="d-flex flex-column gap-3 p-3">
              <h6 className="mb-0 leaderboard-tab-title">Leaderboard</h6>
              <span className="leaderboard-tab-desc">
                Track ranks and win weekly rewards
              </span>
              <div className="leaderboard-tab-arrow-wrapper d-flex align-items-center justify-content-center">
                <img src={rightArrow} width={12} height={12} alt="" />
              </div>
            </div>
            <div className="leaderboard-tab-image-wrapper">
              <img src={leaderboardIcon} className="leaderboard-icon" alt="" />
            </div>
          </NavLink>
          <NavLink
            to={"/leaderboard/airdrop"}
            className="airdrop-tab-wrapper d-flex align-items-center justify-content-between"
          >
            <div className="d-flex flex-column gap-3 p-3">
              <h6 className="mb-0 airdrop-tab-title">Airdrop</h6>
              <span className="airdrop-tab-desc">
                Collect coins to qualify for future airdrops
              </span>
              <div className="airdrop-tab-arrow-wrapper d-flex align-items-center justify-content-center">
                <img src={rightArrow} alt="" />
              </div>
            </div>
            <div className="airdrop-tab-image-wrapper">
              <img src={airdropIcon} className="airdrop-icon" alt="" />
            </div>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default MainView;
